var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTickedCheckbox = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 30,
  height: 30,
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 30,
  rx: 5,
  fill: "#00B0CA"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.54688 15.45L11.4945 19.6375C11.6805 19.9154 11.9894 20.0863 12.3236 20.0963C12.6579 20.1063 12.9764 19.9542 13.1787 19.6879L21.8969 10.8",
  stroke: "#F2F4F7",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTickedCheckbox);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ticked-checkbox.79b80b0a902a56a9459f781297b004c6.svg";